import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import ContentLayout from "../../components/layout-components/ContentLayout";
import CustomIconButton from "../../components/CustomIconButton";
import {
  Box,
  InputBase,
  Tooltip,
  useMediaQuery,
  styled,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
  IconButton,
  Avatar,
  CircularProgress,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import CustomDataTable from "../../components/CustomDataTable";
import CommonUtil from "../../util/CommonUtils";
import { ReactComponent as CompleteIcon } from "../../assets/images/ralvie/complete.svg";
import { ReactComponent as CompleteIconDark } from "../../assets/images/ralvie/complete_dark.svg";
import { ReactComponent as ArchiveIcon } from "../../assets/images/archive-icon.svg";
import { ReactComponent as ArchiveIconDark } from "../../assets/images/archive-icon-dark.svg";
import { ReactComponent as EditIcon } from "../../assets/images/ralvie/EditIcon.svg";
import { ReactComponent as EditIconDark } from "../../assets/images/edit_icon_dark.svg";
import { ReactComponent as AddIcon } from "../../assets/images/ralvie/add-icon.svg";
import { ReactComponent as RefreshIcon } from "../../assets/images/refresh_icon.svg";
import { ReactComponent as FilterIcon } from "../../assets/images/filter-icon.svg";
import { useTranslation } from "react-i18next";
import { GridActionsCellItem } from "@mui/x-data-grid";
import CustomSearchField from "../../components/CustomSearchField";
import AppContext from "../../config/AppContext";
import { ReactComponent as UnarchiveIcon } from "../../assets/images/ralvie/unarchive-icon.svg";
import { ReactComponent as UnarchiveDarkIcon } from "../../assets/images/ralvie/unarchive-darkicon.svg";
import { sidebarContext } from "../../util/context";
import { getSubscriptionLimit } from "../../services/Subscription";
import {
  batchTasksArchive,
  batchTasksComplete,
  exportTaskReportByMember,
  getAllTasks,
  softDeleteTask,
} from "../../services/TaskService";
import ArchiveDialog from "../project/ArchiveDialog";
import { toast } from "sonner";
import TaskFilter from "./TaskFilter";
import { listProject } from "../../services/ProjectService";
import lodash from "lodash";
import { ReactComponent as ExportIcon } from "../../assets/images/ralvie/export-icon.svg";
import CancelDialog from "../project/CancelDialog";
import { ReactComponent as ErrorIcon } from "../../assets/images/ralvie/error-icon.svg";
import { css } from "@emotion/css";
import CustomCheckBox from "../../components/CustomCheckBox";
import CustomButton from "../../components/CustomButton";
import dayjs from "dayjs";
import CustomizedDatePickerReport from "../../components/CustomizedDatePickerReport";
import { ReactComponent as CloseIcon } from "../../assets/images/ralvie/CloseReport.svg";
import { ReactComponent as CloseIconDark } from "../../assets/images/ralvie/CloseReportDark.svg";
import { alpha } from "@mui/system";
import { ReactComponent as ProjectIcon } from "../../assets/images/ralvie/Project.svg";
import { getUserById } from "../../services/MemberService";
import { ReactComponent as EmptyTaskList } from "../../assets/images/ralvie/noTasks.svg";
import { ReactComponent as EmptyTaskListDark } from "../../assets/images/ralvie/noTasksDark.svg";

function Tasks() {
  const { mode } = useContext(AppContext);
  const theme = useTheme();
  const isXlScreen = useMediaQuery(theme.breakpoints.up("xl"));
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [dialogActionType, setDialogActionType] = useState("");
  const { t, i18n } = useTranslation();
  const role = CommonUtil.getRoleCode();
  const [projectFilter, setProjectFilter] = useState("");
  const [isCancelDialogOpen, setIsCancelDialogOpen] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [error, setError] = React.useState(undefined);
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const openFilter = Boolean(filterAnchorEl);
  const [selectedRows, setSelectedRows] = useState([]);
  const [openArchiveDialog, setOpenArchiveDialog] = useState(false);
  const [clearSearch, setClearSearch] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const { subscriptionDetails } = useContext(sidebarContext);
  const [projects, setProjects] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectedProjects, setSelcetdProjects] = React.useState([]);
  const [initialStartDate, setInitialStartDate] = useState(dayjs());
  const [initialEndDate, setInitialEndDate] = useState(dayjs());
  const [initialSelectedProjects, setInitialSelectedProjects] = useState([]);
  const [dataFetched, setDataFetched] = useState(false);
  const [startTime, setStartTime] = useState(dayjs());
  const [endTime, setEndTime] = useState(dayjs());
  const [tasks, setTasks] = useState([]);
  const isStartDateValid =
    startTime.isBefore(endTime, "day") || startTime.isSame(endTime, "day");
  const userId = CommonUtil.getLoggedUser()?.userId;

  const formatSecondsToHours = (secondsStr) => {
    const seconds = parseFloat(secondsStr);
    const hours = Math.floor(seconds / 3600);
    const remainingSeconds = seconds % 3600;
    const minutes = Math.floor(remainingSeconds / 60);
    return `${hours.toString().padStart(2, "0")}h ${minutes.toString().padStart(2, "0")}m`;
  };

  const getRowClassName = () => {
    return selectedRows.length > 0 ? "selectedCheckboxVisible" : "";
  };

  const formattedDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "short",
      year: "numeric",
    };
    return date.toLocaleDateString(i18n.language, options);
  };

  const [filter, setFilter] = useState({
    name: "",
    projectIds: "",
    status: "",
    startDate: null,
    endDate: null,
  });

  useEffect(() => {
    if (!isLoading && rows !== undefined && rows !== null) {
      setDataFetched(true);
    }
  }, [isLoading, rows]);

  useEffect(() => {
    loadTasksData(page, rowsPerPage);
  }, [page, rowsPerPage, filter]);

  const loadTasksData = (pageNumber, pageSize) => {
    setIsLoading(true);

    getAllTasks(filter, pageNumber, pageSize)
      .then((res) => {
        if (res?.data?.code === "RCI0000") {
          let tasks = res.data.data.tasks;
          setRows(res?.data?.data?.tasks);
          setTasks(res?.data?.data?.tasks);
          setTotalRecords(res?.data?.data?.totalCount);
          setPage(res?.data?.data?.currentPage);
        } else {
          setRows([]);
          setTotalRecords(0);
          setPage(1);
        }
      })
      .catch((error) => {
        console.error("API call error:", error);
        setRows([]);
        setTotalRecords(0);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const loadProject = () => {
    listProject()
      .then((res) => {
        if (res.data.code === "RCI0000") {
          setProjects(res.data.data.projects);
        }
      })
      .catch((error) => {
        console.error("Error fetching projects:", error);
      });
  };

  const handleSelecetAll = (value) => {
    if (value) {
      setError(undefined);
      const allProjectIds = projects.map((project) => project.id);
      setSelcetdProjects(allProjectIds);
    } else {
      setSelcetdProjects([]);
    }
  };

  useEffect(() => {
    loadProject();
  }, []);

  const handleApplyFilters = (filters) => {
    setFilter({
      ...filter,
      projectIds: filters.projectIds,
      status: filters.status,
      startDate: filters.startDate,
      endDate: filters.endDate,
    });
    setPage(1);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const resetFilter = () => {
    setFilter({
      name: "",
      projectIds: "",
    });
    setStatusFilter("");
    setStartDate(null);
    setEndDate(null);
    setRefresh(true);
    setProjectFilter([]);
    setClearSearch(true);
  };

  const handleCloseCancelDialog = () => {
    setIsCancelDialogOpen(false);
  };

  const handleConfirmCancel = () => {
    setError(undefined);
    setOpen(false);
    setIsCancelDialogOpen(false);
    handleSelecetAll(false);
    setStartTime(dayjs());
    setEndTime(dayjs());
  };

  const onCloseFilter = (e) => {
    if (e === "Apply" || e === "Reset") {
      setProjectFilter(projectFilter);
      setFilterAnchorEl(null);
    } else {
      setStatusFilter(filter.status ? statusFilter : "");
      setStartDate(filter.startDate ? startDate : null);
      setEndDate(filter.endDate ? endDate : null);
      setProjectFilter(filter.projectIds ? projectFilter : []);
      setFilterAnchorEl(null);
    }
  };

  const handleArchiveTask = (id) => {
    setSelectedRows([id]);
    setSelectedTaskId(id);
    setOpenArchiveDialog(true);
    setDialogActionType("archive");
  };

  const handleCompleteTask = (id) => {
    setSelectedRows([id]);
    setSelectedTaskId(id);
    setOpenArchiveDialog(true);
    setDialogActionType("completeTask");
  };

  const handleCloseDialog = () => {
    setOpenArchiveDialog(false);
    setSelectedRows([]);
  };

  const handleClose = () => {
    setError(undefined);
    setOpen(false);
    handleSelecetAll(false);
    setStartTime(dayjs());
    setEndTime(dayjs());
  };

  const handleCancelButton = () => {
    const isDateRangeModified =
      !dayjs(startTime).isSame(dayjs(initialStartDate), "day") ||
      !dayjs(endTime).isSame(dayjs(initialEndDate), "day");
    const isCheckboxModified =
      JSON.stringify(selectedProjects) !==
      JSON.stringify(initialSelectedProjects);
    // ||
    // isIncludeMemberContribution !== initialIncludeMemberContribution;
    if (isDateRangeModified || isCheckboxModified) {
      setIsCancelDialogOpen(true);
    } else {
      handleClose();
    }
  };

  const [member, setMember] = useState("");

  useEffect(() => {
    const fetchUserData = async (userId) => {
      if (userId) {
        const userData = await getUserById(userId);
        if (userData) {
          setMember(userData?.data?.data?.ralvieId);
        }
      }
    };

    if (userId) {
      fetchUserData(userId);
    }
  }, [userId]);

  const handleSubmit = async () => {
  if (selectedProjects?.length < 1) {
    setError(t("RAL0718"));
    return;
  }

  setIsLoading(true);

  try {
    var utc = require("dayjs/plugin/utc");
    var timezone = require("dayjs/plugin/timezone");
    dayjs.extend(utc);
    dayjs.extend(timezone);
    let dateTz = dayjs.tz(startTime, CommonUtil.getTimeZoneId());
    let startedTime = dateTz.startOf("day");
    dateTz = dayjs.tz(endTime, CommonUtil.getTimeZoneId());
    let endedTime = dateTz.endOf("day");
    let start = startedTime.isUTC()
      ? startedTime.format()
      : startedTime.utc().format();
    let end = endedTime.isUTC() ? endedTime.format() : endedTime.utc().format();

    await exportTaskReportByMember(selectedProjects, member, start, end);
    handleClose();
  } catch (error) {
    setError(t("RAL1192"));
  } finally {
    setIsLoading(false);
  }
};

  const handleEditTask = useCallback(
    (id) => {
      if (id) {
        navigate(`/tasks/${id}`);
      }
    },
    [navigate]
  );

  const handleAddMembers = () => {
    navigate("/tasks/add");
  };

  const searchOnChange = useCallback(
    lodash.throttle(
      (value) => {
        setFilter({ ...filter, name: value });
        setPage(1);
      },
      1200,
      { leading: false, trailing: true }
    ),
    []
  );

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const selectedUserDetails = rows.filter((user) =>
    selectedRows.includes(user.id)
  );

  const handleSelection = (id) => {
    setError(undefined);
    setSelcetdProjects((prevSelected) => {
      if (prevSelected.includes(id)) {
        return prevSelected.filter((pid) => pid !== id);
      } else {
        return [...prevSelected, id];
      }
    });
  };

  const checkProjectSelection = (id) => {
    return selectedProjects.includes(id);
  };

  const projectCard = (project) => {
    return (
      <Box
        className="projectCardOuter"
        sx={{
          border: `1px solid ${
            mode === "light" ? "#eaebef !important" : "#313131 !important"
          }`,
        }}
      >
        <CustomCheckBox
          id="projectreport-select-checkbox"
          onChange={() => handleSelection(project?.id)}
          checked={checkProjectSelection(project?.id)}
        />
        <Avatar
          id="projectreport-project-avatar"
          className="projectAvatar"
          sx={{
            width: "46px",
            height: "46px",
            backgroundColor: (theme) => alpha(project?.color, 0.15),
            ...(project?.color?.startsWith("#f") && {
              border: "1px solid #E0E0E0",
            }),
            ...(project?.color?.startsWith("#1") && {
              border: "1px solid #000000",
            }),
            marginLeft: 1,
          }}
        >
          <ProjectIcon
            id="projectreport-project-icon"
            fill={project?.color}
            style={{
              ...(project?.color?.startsWith("#f") && {
                fill: "#E0E0E0",
              }),
              ...(project?.color?.startsWith("#1") && {
                fill: "#000000",
              }),
            }}
            opacity={0.5}
          />
        </Avatar>
        <Box display="flex" flexDirection={"column"}>
          <Tooltip title={project?.name}>
            <Typography
              id="projectreport-project-name"
              className="projectName"
              sx={{
                color:
                  mode === "light"
                    ? "#242424 !important"
                    : "#F8F8F8 !important",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "400px",
                marginTop:
                  !project?.clientName && CommonUtil.getOS() === "MacOS"
                    ? "6.5px"
                    : "",
              }}
            >
              {project?.name}
            </Typography>
          </Tooltip>
          {project?.clientName && (
            <Tooltip title={project?.clientName || ""}>
              <Typography
                id="projectreport-client-name"
                className="projectClientName"
                sx={{
                  color:
                    mode === "light"
                      ? "#242424cc !important"
                      : "#f8f8f8cc !important",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  maxWidth: "400px",
                }}
              >
                {project?.clientName}
              </Typography>
            </Tooltip>
          )}
        </Box>
      </Box>
    );
  };

  const actions = (
    <Box display="flex" alignItems="center">
      {/* {role !== "EMPLOYEE" && role !== "CLIENT" && role !== "TEAM LEAD" && ( */}
      {role !== "CLIENT" && (
        <>
          {selectedUserDetails.length > 0 && (
            <>
              {selectedUserDetails[0]?.status === "ARCHIVED" ? (
                <Box pr={2}>
                  {/* <Box
                    sx={{
                      "& .unarchive_svg": {
                        transition: "color 0.3s ease",
                        color:
                          mode === "dark" ? "var(--color-33-50)" : "#242424cc",
                      },
                      "&:hover": {
                        "& .hover-text, & .unarchive_svg": {
                          color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                        },
                      },
                    }}
                  >
                    <CustomIconButton
                      id="btn-unarchive-project"
                      title={t("RAL0535")}
                      size={isXlScreen ? "large" : "md"}
                      variant="square"
                      lightMode={
                        <UnarchiveIcon
                          id="member-archive-icon"
                          className="unarchive_svg"
                          height={isXlScreen ? "18px" : "14px"}
                        />
                      }
                      darkMode={
                        <UnarchiveDarkIcon
                          id="member-archive-icon"
                          className="unarchive_svg"
                          height={isXlScreen ? "18px" : "14px"}
                        />
                      }
                      onClick={() => setOpenUnarchiveDialog(true)}
                    />
                  </Box> */}
                </Box>
              ) : (
                <>
                  <Box pr={2}>
                    <Box
                      sx={{
                        "& .archive_svg": {
                          transition: "color 0.3s ease",
                          color:
                            mode === "dark"
                              ? "var(--color-33-50)"
                              : "#242424cc",
                        },
                        "&:hover": {
                          "& .hover-text, & .archive_svg": {
                            color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                          },
                        },
                      }}
                    >
                      <CustomIconButton
                        id="btn-archive-member"
                        title={t("RAL0173")}
                        size={isXlScreen ? "large" : "md"}
                        variant="square"
                        lightMode={
                          <ArchiveIcon
                            id="member-archive-icon"
                            className="archive_svg"
                            height={isXlScreen ? "18px" : "14px"}
                          />
                        }
                        darkMode={
                          <ArchiveIconDark
                            id="member-archive-icon"
                            className="archive_svg"
                            height={isXlScreen ? "18px" : "14px"}
                          />
                        }
                        onClick={() => {
                          setOpenArchiveDialog(true);
                          setDialogActionType("archive");
                        }}
                      />
                    </Box>
                  </Box>
                </>
              )}
            </>
          )}
        </>
      )}

      {!selectedRows.length && (
        <>
          <Box item pr={2} className="memberSearchBox">
            <CustomSearchField
              id="btn-member-search"
              name="btn-member-search"
              clearSearch={clearSearch}
              // onChange={(value) => setFilter({ ...filter, name: value })}
              onChange={searchOnChange}
              label={t("RAL1120")}
              value={filter.name}
              size={isXlScreen ? "large" : "md"}
              onClick={(value) => {
                // setClearSearch(false);
                setFilter({ ...filter, name: value });
              }}
              onClear={(value) => {
                setClearSearch(true);
                setFilter({ ...filter, name: value });
              }}
            />
          </Box>

          <Box item pr={2}>
            <Box
              sx={{
                "& .filter_svg": {
                  transition: "color 0.3s ease",
                  color: mode === "dark" ? "var(--color-33-50)" : "#242424cc",
                },
                "&:hover": {
                  "& .hover-text, & .filter_svg": {
                    color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                  },
                },
              }}
            >
              <CustomIconButton
                id="btn-filter-project"
                title={t("RAL0224")}
                size={isXlScreen ? "large" : "md"}
                variant="square"
                lightMode={
                  <FilterIcon
                    id="member-filter-icon"
                    className="filter_svg"
                    height={isXlScreen ? "18px" : "14px"}
                  />
                }
                darkMode={
                  <FilterIcon
                    id="member-filter-icon"
                    className="filter_svg"
                    height={isXlScreen ? "18px" : "14px"}
                  />
                }
                onClick={handleFilterClick}
              />
            </Box>
            <TaskFilter
              open={openFilter}
              anchorEl={filterAnchorEl}
              onClose={(e) => onCloseFilter(e)}
              status={statusFilter}
              setStatusFilter={setStatusFilter}
              projectsList={projects}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              onApplyFilters={handleApplyFilters}
              projectFilter={projectFilter}
              setProjectFilter={setProjectFilter}
            />
          </Box>

          <Box item pr={2}>
            <Box
              sx={{
                "& .refresh_svg": {
                  transition: "color 0.3s ease",
                  color: mode === "dark" ? "var(--color-33-50)" : "#242424cc",
                },
                "&:hover": {
                  "& .hover-text, & .refresh_svg": {
                    color: mode === "dark" ? "#f8f8f8cc" : "#242424",
                  },
                },
              }}
            >
              <CustomIconButton
                id="btn-refresh-project"
                title={t("RAL0169")}
                size={isXlScreen ? "large" : "md"}
                variant="square"
                lightMode={
                  <RefreshIcon
                    id="member-refresh-icon"
                    className="refresh_svg"
                    height={isXlScreen ? "18px" : "14px"}
                  />
                }
                darkMode={
                  <RefreshIcon
                    id="member-refresh-icon"
                    className="refresh_svg"
                    height={isXlScreen ? "18px" : "14px"}
                  />
                }
                onClick={() => resetFilter()}
              />
            </Box>
          </Box>

          <Box item pr={2}>
            <CustomIconButton
              id="btn-custom-export-project"
              name="btn-custom-export-project"
              title={t("RAL1189")}
              size={isXlScreen ? "large" : "md"}
              variant="square"
              type="contained"
              border={"none"}
              lightMode={<ExportIcon height={isXlScreen ? "18px" : "14px"} />}
              darkMode={<ExportIcon height={isXlScreen ? "18px" : "14px"} />}
              onClick={handleClickOpen}
            />
            <Dialog
              className="ExportProjectReport"
              open={open}
              onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              fullScreen={fullScreen}
              fullWidth={true}
            >
              <Box
                sx={{
                  backgroundColor: mode === "light" ? "#ffffff" : "#101010",
                }}
              >
                <Box
                  sx={{
                    position: "sticky",
                    top: 8,
                    backgroundColor: mode === "light" ? "#ffffff" : "#101010",
                    zIndex: 2,
                  }}
                >
                  <DialogTitle
                    className="ExportTitle"
                    sx={{ color: mode === "light" ? "#242424" : "#f8f8f8" }}
                    id="alert-dialog-title"
                  >
                    {t("RAL0478")}
                    <IconButton
                      edge="end"
                      color="inherit"
                      onClick={handleClose}
                      sx={{
                        position: "absolute",
                        right: 36,
                        top: 8,
                        "&:hover": {
                          backgroundColor:
                            mode === "dark"
                              ? "rgba(255, 255, 255, 0.2)"
                              : "rgba(0, 0, 0, 0.1)",
                          borderRadius: "4px",
                        },
                      }}
                    >
                      {mode === "light" ? <CloseIcon /> : <CloseIconDark />}
                    </IconButton>
                  </DialogTitle>
                  <DialogContent className="exportDialogContent" width={"100%"}>
                    <Box py={2}>
                      <Typography
                        sx={{
                          color: mode === "light" ? "#242424cc" : "#f8f8f8cc",
                        }}
                        className="ExportDesc"
                        id="alert-dialog-title-info"
                      >
                        {t("RAL0479")}
                      </Typography>
                    </Box>
                    <Box display="flex">
                      <Box>
                        <Typography
                          sx={{
                            color:
                              mode === "light"
                                ? "#242424 !important"
                                : "#F8F8F8 !important",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            marginTop: 1.5,
                          }}
                          className={css`
                            font: normal normal normal 16px/19px Gotham;
                            letter-spacing: 0px;
                            font-weight: 600;
                          `}
                        >
                          <span
                            className={css`
                              font: normal normal normal 16px / 20px Gothambold !important;
                              letter-spacing: 0px;
                              margin-right: 1.6rem;
                              opacity: 0.8;
                            `}
                            id="alert-dialog-daterange"
                          >
                            {t("RAL0480")}
                          </span>
                        </Typography>
                      </Box>
                      <Box display={"flex"} flexDirection={"column"}>
                        <Box display={"flex"} alignItems={"center"}>
                          <Box
                          // className={`${mode === 'dark' ? "customDatePickerInputBoxBackGround" : ""}`}
                          >
                            <CustomizedDatePickerReport
                              id="btn-start-clndr"
                              onChange={(date) => {
                                setStartTime(date);
                              }}
                              value={startTime}
                              maxDate={dayjs().utc().format()}
                            />
                          </Box>
                          <Box mx={1}> - </Box> {/* Added mx for spacing */}
                          <Box
                          // className={`${mode === 'dark' ? "customDatePickerInputBoxBackGround" : ""}`}
                          >
                            <CustomizedDatePickerReport
                              id="btn-end-clndr"
                              onChange={(date) => {
                                setEndTime(date);
                              }}
                              value={endTime}
                              maxDate={dayjs().utc().format()}
                            />
                          </Box>
                        </Box>
                        {!isStartDateValid && (
                          <Box
                            display={"flex"}
                            alignItems={"center"}
                            pt={1}
                            pl={2}
                          >
                            <Box pr={1} display="flex" alignItems="center">
                              <ErrorIcon />
                            </Box>
                            <Box display="flex" alignItems="center">
                              <Typography
                                id="alert-dialog-date-message"
                                className="helper-text"
                              >
                                {t("RAL0483")}
                              </Typography>
                            </Box>
                          </Box>
                        )}
                      </Box>
                    </Box>

                    <Box
                      py={1}
                      className={css`
                        border-radius: 5px;
                        opacity: 1;
                        display: flex;
                        align-items: center;
                        margin-bottom: 1px;
                      `}
                    >
                      <CustomCheckBox
                        id="projectreport-select-checkbox"
                        onChange={() =>
                          handleSelecetAll(
                            selectedProjects.length !== projects.length
                          )
                        }
                        checked={
                          projects.length > 0 &&
                          selectedProjects.length === projects.length
                        }
                      />

                      <Box display="flex" flexDirection={"column"} rowGap={0.5}>
                        <Typography
                          sx={{
                            color:
                              mode === "light"
                                ? "#242424 !important"
                                : "#F8F8F8 !important",
                          }}
                          className={css`
                            font: normal normal normal 16px/19px GothamMedium;
                            letter-spacing: 0px;
                          `}
                        >
                          <span
                            className={css`
                              font: normal normal 16px/19px Gotham;
                              letter-spacing: 0px;
                              margin-right: 11.3rem;
                            `}
                            id="projectreport-selectall-text"
                          >
                            {t("RAL0482")}
                          </span>
                        </Typography>
                      </Box>
                    </Box>
                    {error && (
                      <Box display={"flex"} alignItems={"center"}>
                        <Box item pr={0.5} mt={0.5}>
                          {<ErrorIcon id="projectreport-error-icon" />}
                        </Box>
                        <Box item>
                          <Typography
                            id="projectreport-error-message"
                            className="helper-text"
                          >
                            {error}
                          </Typography>
                        </Box>
                      </Box>
                    )}
                  </DialogContent>
                </Box>

                <DialogContent className="exportDialogContent" width={"100%"}>
                  <Box
                    className="projectCardDiv"
                    display={"flex"}
                    flexDirection={"column"}
                    rowGap={1}
                  >
                    {projects?.map((project) => projectCard(project))}
                  </Box>
                </DialogContent>
                <DialogActions
                  className="DialogActionsDiv"
                  sx={{
                    backgroundColor:
                      mode === "light"
                        ? "#FFFFFF !important"
                        : "#121212 !important",
                  }}
                >
                  <Box className="DialogActionsBtns">
                    <CustomButton
                      place="sp-cancel"
                      id="btn-cancel-project-report"
                      name="btn-cancel-member"
                      variant="outlined"
                      size="large"
                      fullWidth="fullWidth"
                      height="50px"
                      minWidth="150px"
                      onClick={handleCancelButton}
                    >
                      <span id="btn-cancel-member">{t("RAL0177")}</span>
                    </CustomButton>
                    <CustomButton
                      id="btn-add-project-report"
                      name="btn-add-project-report"
                      variant="contained"
                      size="large"
                      fullWidth="fullWidth"
                      height="50px"
                      minWidth="150px"
                      disabled={!isStartDateValid}
                      onClick={() => {
                        handleSubmit();
                      }}
                    >
                      {isLoading ? (
                        <CircularProgress size={24} color="inherit" />
                      ) : (
                       <span id="btn-add-member">{t("RAL0047")}</span>
                      )}
                    </CustomButton>
                  </Box>
                  <CancelDialog
                    open={isCancelDialogOpen}
                    onClose={handleCloseCancelDialog}
                    onConfirm={handleConfirmCancel}
                    header={t("RAL0742")}
                    message={t("RAL0743")}
                  />
                </DialogActions>
              </Box>
            </Dialog>
          </Box>

          {role !== "CLIENT" && (
            <CustomIconButton
              id="btn-custom-add-member"
              name="btn-custom-add-member"
              title={t("RAL1124")}
              size={isXlScreen ? "large" : "md"}
              variant="square"
              type="contained"
              border={"none"}
              lightMode={
                <AddIcon
                  id="member-add-icon"
                  height={isXlScreen ? "18px" : "14px"}
                />
              }
              darkMode={
                <AddIcon
                  id="member-add-icon"
                  height={isXlScreen ? "18px" : "14px"}
                />
              }
              onClick={handleAddMembers}
            />
          )}
        </>
      )}
    </Box>
  );

  const computeTaskStatus = (task) => {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const { startDate, endDate, status } = task;
    const taskStartDate = new Date(startDate);
    taskStartDate.setHours(0, 0, 0, 0);
    const taskEndDate = endDate ? new Date(endDate) : null;
    if (taskEndDate) taskEndDate.setHours(0, 0, 0, 0);

    if (status === "ARCHIVED") return "ARCHIVED";
    if (status === "COMPLETED") return "COMPLETED";
    if (taskStartDate > currentDate && status !== "COMPLETED") {
      return "NOT STARTED";
    }
    if (taskEndDate) {
      if (taskEndDate > currentDate && status !== "COMPLETED") {
        return "IN PROGRESS";
      }
      if (
        taskEndDate < currentDate &&
        status !== "COMPLETED" &&
        status !== "ARCHIVED"
      ) {
        return "OVERDUE";
      }
      if (taskEndDate.getTime() === currentDate.getTime()) {
        return "IN PROGRESS";
      }
    } else if (status !== "COMPLETED") {
      return "IN PROGRESS";
    }
    return "COMPLETED";
  };

  const columns = React.useMemo(() => [
    {
      field: "taskId",
      headerName: t("RAL1138"),
      sortable: false,
      flex: 0.6,
      width: 5,
      renderCell: (params) => (
        <Tooltip
          title={params.row.taskId}
          placement="bottom-start"
          // disableInteractive
        >
          <span style={{ textTransform: "none" }}>{params.row.taskId}</span>
        </Tooltip>
      ),
    },
    {
      field: "title",
      headerName: t("RAL1109"),
      sortable: false,
      flex: 1,
      width: 10,

      renderCell: (params) => (
        <Tooltip
          title={params.row.title}
          placement="bottom-start"
          // disableInteractive
        >
          <span style={{ textTransform: "none" }}>{params.row.title}</span>
        </Tooltip>
      ),
    },
    {
      field: "description",
      headerName: t("RAL1117"),
      sortable: false,
      flex: 1,
      width: 10,
      renderCell: (params) => (
        <Tooltip
          title={params.row.description}
          placement="bottom-start"
          // disableInteractive
        >
          <span style={{ textTransform: "none" }}>
            {params.row.description}
          </span>
        </Tooltip>
      ),
    },

    {
      field: "startDate",
      headerName: t("RAL1121"),
      sortable: false,
      flex: 1,
      width: 10,
      renderCell: (params) => (
        <Tooltip
          title={formattedDate(params.row.startDate)}
          placement="bottom-start"
          // disableInteractive
        >
          <span>{formattedDate(params.row.startDate)}</span>
        </Tooltip>
      ),
    },

    {
      field: "endDate",
      headerName: t("RAL1122"),
      sortable: false,
      flex: 1,
      width: 10,
      renderCell: (params) => (
        <Tooltip
          title={
            !CommonUtil.isEmpty(params.row.endDate)
              ? formattedDate(params.row.endDate)
              : "Ongoing"
          }
          placement="bottom-start"
          // disableInteractive
        >
          {!CommonUtil.isEmpty(params.row.endDate)
            ? formattedDate(params.row.endDate)
            : "Ongoing"}
        </Tooltip>
      ),
    },
    {
      field: "project",
      headerName: t("RAL1118"),
      sortable: false,
      flex: 1,
      width: 10,
      renderCell: (params) => (
        <Tooltip
          title={params.row.project.name}
          placement="bottom-start"
          // disableInteractive
        >
          <span>{params.row.project.name}</span>
        </Tooltip>
      ),
    },

    {
      field: "loggedHours",
      headerName: t("RAL1119"),
      sortable: false,
      flex: 1,
      width: 10,
      renderCell: (params) => {
        const formattedTime = formatSecondsToHours(params.row.loggedHours);
        return (
          <Tooltip
            title={formattedTime}
            placement="bottom-start"
            // disableInteractive
          >
            <span>{formattedTime}</span>
          </Tooltip>
        );
      },
    },

    {
      field: "status",
      headerName: t("RAL0267"),
      sortable: false,
      flex: 1,
      width: 10,
      renderCell: (params) => {
        const status = computeTaskStatus(params.row);

        const statusClass =
          status === "COMPLETED"
            ? "project-complete"
            : status === "IN PROGRESS"
              ? "project-present"
              : status === "ARCHIVED"
                ? mode === "dark"
                  ? "project-archived-dark"
                  : "project-archived"
                : status === "OVERDUE"
                  ? "project-overtime"
                  : status === "NOT STARTED"
                    ? "project-future"
                    : "";

        const formatStatus = (statusKey) => {
          const translationKeys = {
            COMPLETED: "RAL0661".toUpperCase(),
            "IN PROGRESS": "RAL0659".toUpperCase(),
            ARCHIVED: "RAL0234".toUpperCase(),
            OVERDUE: "RAL0660".toUpperCase(),
            "NOT STARTED": "RAL1106".toUpperCase(),
          };
          const translatedKey = translationKeys[statusKey] || statusKey;
          const translatedText = t(translatedKey);

          return (
            translatedText.charAt(0).toUpperCase() +
            translatedText.slice(1).toLowerCase()
          );
        };

        return (
          <Tooltip
            title={formatStatus(status)}
            placement="bottom-start"
            // disableInteractive
          >
            <span className={statusClass} style={{ fontSize: "14px" }}>
              {formatStatus(status)}
            </span>
          </Tooltip>
        );
      },
    },

    role !== "CLIENT" && {
      headerName: filter.status === "ARCHIVED" ? "" : t("RAL0538"),
      type: "actions",
      flex: 1,
      width: 10,
      renderCell: (params) => {
        const computedStatus = computeTaskStatus(params.row);
        const isCompleted = computedStatus === "COMPLETED";
        const isRestrictedRole = role === "EMPLOYEE" || role === "CLIENT";

        return (
          <>
            {params.row.status === "ARCHIVED" ? (
              <div style={{ marginLeft: "10%" }}>
                {/* <Tooltip title={t("RAL0535")}>
                  <GridActionsCellItem
                    icon={
                      mode === "dark" ? (
                        <UnarchiveDarkIcon
                          id="project-archive-icon"
                          className="icon"
                        />
                      ) : (
                        <UnarchiveIcon
                          id="project-archive-icon"
                          className="icon"
                        />
                      )
                    }
                    label={t("RAL0535")}
                    onClick={() => handleUnarchiveProject(params.row.id)}
                  />
                </Tooltip> */}
              </div>
            ) : (
              <div>
                {!isCompleted && (
                  <Tooltip title={t("RAL0172")}>
                    <span>
                      <GridActionsCellItem
                        icon={
                          mode === "dark" ? (
                            <EditIconDark
                              id="project-edit-icon"
                              className="icon"
                            />
                          ) : (
                            <EditIcon id="project-edit-icon" className="icon" />
                          )
                        }
                        label={t("RAL0172")}
                        style={{
                          marginRight: "9px",
                        }}
                        onClick={() => handleEditTask(params.row.id)}
                        disabled={isCompleted}
                      />
                    </span>
                  </Tooltip>
                )}

                {computedStatus !== "COMPLETED" && (<Tooltip title={t("RAL0173")} >
                  <GridActionsCellItem
                    icon={
                      mode === "dark" ? (
                        <ArchiveIconDark
                          id="project-archive-icon"
                          className="icon"
                        />
                      ) : (
                        <ArchiveIcon
                          id="project-archive-icon"
                          className="icon"
                        />
                      )
                    }
                    label={t("RAL0173")}
                    style={{
                      marginRight: isCompleted ? "0px" : "9px",
                      marginLeft: isCompleted ? "37px" : "0px",
                    }}
                    onClick={() => handleArchiveTask(params.row.id)}
                  />
                </Tooltip>)}

                {computedStatus !== "COMPLETED" &&
                  params.row.status !== "ARCHIVED" && (
                    <Tooltip title={t("RAL0545")}>
                      <GridActionsCellItem
                        icon={
                          mode === "light" ? (
                            <CompleteIcon
                              id="project-complete-icon"
                              className="icon"
                            />
                          ) : (
                            <CompleteIconDark
                              id="project-complete-icon"
                              className="icon"
                            />
                          )
                        }
                        label={t("RAL0545")}
                        style={{ marginRight: "9px" }}
                        onClick={() => handleCompleteTask(params.row.id)}
                      />
                    </Tooltip>
                  )}
              </div>
            )}
          </>
        );
      },
    },
  ]);

  const handleRowSelection = (newSelection) => {
    const allowedSelection = newSelection.filter((id) => {
      const row = tasks.find((t) => t.id === id);
      return computeTaskStatus(row) !== "COMPLETED";
    });
    setSelectedRows(allowedSelection);
  };

  const handleConfirmCompleteTask = async () => {
    try {
      let taskIds = selectedRows.length > 0 ? selectedRows : [selectedTaskId];
      if (taskIds.length >= 1) {
        const payload = { ids: taskIds };
        const res = await batchTasksComplete(payload);
        if (res.data?.code === "RCI0000") {
          loadTasksData(page, rowsPerPage);
          toast.success(t("RAL1125"));
          setSelectedRows([]);
          handleCloseDialog();
        } else if (res?.data.code === "RCE0275") {
          toast.error(res.data?.message);
          handleCloseDialog();
        } else {
          toast.error(res.data?.message);
        }
      } else {
        toast.error(t("RAL1126"));
      }
    } catch (error) {
      console.log(error);
      toast.error(t("RAL1128"));
    }
  };

  const handleConfirmArchive = async () => {
    try {
      let taskIds = selectedRows.length > 0 ? selectedRows : [selectedTaskId];
      if (taskIds.length === 1) {
        const response = await softDeleteTask(taskIds[0]);
        if (response.data?.code === "RCI0000") {
          loadTasksData(page, rowsPerPage);
          toast.success(t("RAL1127"));
          setSelectedRows([]);
          handleCloseDialog();
        } else {
          toast.error(response.data?.message);
        }
      } else if (taskIds.length > 1) {
        const payload = { ids: taskIds };
        const res = await batchTasksArchive(payload);
        if (res.data?.code === "RCI0000") {
          loadTasksData(page, rowsPerPage);
          toast.success(t("RAL1127"));
          setSelectedRows([]);
          handleCloseDialog();
        } else {
          toast.error(res.data?.message);
        }
      } else {
        toast.error(t("RAL1126"));
      }
    } catch (error) {
      console.log(error);
      toast.error(t("RAL1129"));
    }
  };

  return CommonUtil.getRoleCode() !== "CLIENT" ? (
    <>
      <div>
        <ContentLayout
          id="header-text-task-name"
          title={t("RAL1116")}
          rowtitle={
            selectedRows.length > 0 ? (
              <strong className="selected-tasks">
                {selectedRows.length} {t("RAL1123").toLocaleLowerCase()}
                {selectedRows.length > 1 ? "s" : ""} {t("RAL0599")}
              </strong>
            ) : null
          }
          actions={actions}
          isLoading={isLoading}
        >
          {isLoading ? (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="300px"
            >
               {/* <CircularProgress /> */}
            </Box>
          ) : (
            <>
              <CustomDataTable
                page={page - 1}
                totalRecords={totalRecords}
                rowsPerPage={rowsPerPage}
                columns={columns}
                rows={rows}
                checkboxSelection={true}
                rowSelectionModel={selectedRows}
                onRowSelectionModelChange={handleRowSelection}
                getRowClassName={getRowClassName}
                noDataLabel={t("RAL1160")}
                noDataComponent={
                rows.length === 0 && !isLoading ? (
                  <Box
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      width: "100%",
                      alignItems: "center",
                      height: "100%",
                    }}
                  >
                    {mode === "dark" ? <EmptyTaskListDark /> : <EmptyTaskList />}

                    <Typography
                      id="text-project-message"
                      variant="h6"
                      className="noProjectError"
                      mt={2}
                    >
                      {t("RAL1160")}
                    </Typography>
                  </Box>
                ) : null}
                onPageChange={(e) => {
                  const CurrentPage = CommonUtil.getPageNumber(e);
                  setPage(CurrentPage);
                }}
                onPageSizeChange={(e) => {
                  setRowsPerPage(e);
                  setPage(1);
                }}
              />
            </>
          )}

          <ArchiveDialog
            open={openArchiveDialog}
            onClose={handleCloseDialog}
            onConfirm={
              dialogActionType === "completeTask"
                ? handleConfirmCompleteTask
                : handleConfirmArchive
            }
            name={t("RAL1123").toLowerCase()}
            type="Task"
            actionType={dialogActionType}
          />
        </ContentLayout>
      </div>
    </>
  ) : (
    <></>
  );
}

export default Tasks;
